import {UserSettings} from "../interfaces";
import {createContext, ReactNode, useContext, useState} from "react";
import {useSocket} from "../SocketContext";
import {useEvent} from "../../../hooks/useEvent";
import {rpc_call} from "../rpc";

const Context = createContext<UserSettingsContextData>(null!);

export default function UserSettingsContext(props: {children: ReactNode}) {
    const socket = useSocket()

    const defaultSettings = {
        dashboardLayoutJSON: undefined,
        compactLayout: false,
    }

    const [settings, setSettings] = useState<UserSettings>(defaultSettings)

    useEvent("socketOpen", () => {
        rpc_call<UserSettings>(socket, "SettingsInit").then(init => {
            if (init){
                setSettings(init)
            }
        })
    })

    const update = async (dashboardLayoutJson: string | undefined, compactLayout: boolean | undefined) => {
        setSettings(s => {
            return {
                dashboardLayoutJSON: dashboardLayoutJson ?? s?.dashboardLayoutJSON,
                compactLayout: compactLayout ?? s?.compactLayout ?? defaultSettings.compactLayout,
            }
        })
        await rpc_call(socket, "SettingsUpdate", dashboardLayoutJson, compactLayout);
    }

    const context = {
        settings,
        update
    }

    return (
        <Context.Provider value={context}>
            {props.children}
        </Context.Provider>
    )
}

export const useUserSettings = () => useContext(Context)

interface UserSettingsContextData{
    settings: UserSettings
    update: (dashboardLayoutJson: string | undefined, compactLayout: boolean | undefined) => Promise<void>
}